var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgBedroom = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 17,
    viewBox: "0 0 20 17",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 6.07143V2.42857C17.5 1.78447 17.2366 1.16676 16.7678 0.711312C16.2989 0.255866 15.663 0 15 0H5C4.33696 0 3.70107 0.255866 3.23223 0.711312C2.76339 1.16676 2.5 1.78447 2.5 2.42857V6.07143C1.83696 6.07143 1.20107 6.3273 0.732233 6.78274C0.263392 7.23819 0 7.8559 0 8.5V14.5714H1.6625L2.5 17H3.75L4.5875 14.5714H15.4125L16.25 17H17.5L18.3375 14.5714H20V8.5C20 7.8559 19.7366 7.23819 19.2678 6.78274C18.7989 6.3273 18.163 6.07143 17.5 6.07143ZM8.75 6.07143H5V2.42857H8.75M15 6.07143H11.25V2.42857H15V6.07143Z",
    fill: "#133155"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgBedroom, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/bedroom.be02fa36.svg";
export { ForwardRef as ReactComponent };